export default __webpack_public_path__ + "static/media/contact-header-img.edd636c6.png";